import { useState } from 'react';
import { App, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { useCreateRuleGroup, useUpdateRuleGroup } from '@/features/agreements/hooks/useRuleGroups';
import { ruleGroupsQueryKeys } from '@/features/agreements/hooks/useRuleGroups';
import { RulesDrawer } from './RulesDrawer';

const { Text } = Typography;

const AGREEMENT_TITLE = 'Definir reglas del convenio';
const AGREEMENT_DESCRIPTION = 'Las reglas determinan cuándo el convenio puede ser aplicado durante una cotización. Todas las condiciones definidas deben cumplirse según la lógica configurada.';

export const AddRulesButton = ({ agreementId, ruleGroup, ...props }) => {
  const { notification } = App.useApp();
  const queryClient = useQueryClient();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const createRuleGroupMutation = useCreateRuleGroup();
  const updateRuleGroupMutation = useUpdateRuleGroup();
  const isEditMode = !!ruleGroup;

  const handleSave = async ({ ruleGroupPayload, ruleGroupId }) => {
    if (ruleGroupId != null) {
      await updateRuleGroupMutation.mutateAsync({
        id: ruleGroupId,
        data: ruleGroupPayload,
      });
      notification.success({
        message: <Text strong>Reglas actualizadas</Text>,
        description: '¡Las reglas del convenio se han actualizado correctamente!',
      });
    } else {
      await createRuleGroupMutation.mutateAsync({
        data: {
          ...ruleGroupPayload,
          agreementId,
        },
      });
      notification.success({
        message: <Text strong>Reglas creadas</Text>,
        description: '¡Las reglas del convenio se han creado correctamente!',
      });
    }
    void queryClient.invalidateQueries({
      queryKey: ruleGroupsQueryKeys.list({ agreementId }),
    });
  };

  return (
    <>
      <Button
        type='primary'
        icon={<PlusOutlined />}
        onClick={() => setDrawerOpen(true)}
        {...props}
      >
        Definir condiciones
      </Button>
      <RulesDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        title={AGREEMENT_TITLE}
        description={AGREEMENT_DESCRIPTION}
        ruleGroup={ruleGroup || null}
        onSave={handleSave}
        submitButtonText={isEditMode ? 'Guardar' : 'Crear condición'}
        rulesRequired={true}
      />
    </>
  );
};
